// وحدات القياس لحقول التسعير — تُصاغ نصيّاً وفق الحقل والعملة الحالية.
export const unitOf = (kind, currency, t) => {
  if (!kind) return "";
  if (kind === "percent") return "%";
  if (kind === "per_token") return `${currency}/${t("tokens.unitToken")}`;
  if (kind === "per_face_month") return `${currency}/${t("tokens.unitFace")}/${t("tokens.unitMonth")}`;
  if (kind === "per_image") return `${currency}/${t("tokens.unitImage")}`;
  if (kind === "per_check") return `${currency}/${t("tokens.unitCheck")}`;
  if (kind === "per_branch") return `${currency}/${t("platformExtra.unitBranch")}/${t("tokens.unitMonth")}`;
  if (kind === "per_employee") return `${currency}/${t("platformExtra.unitEmployee")}/${t("tokens.unitMonth")}`;
  if (kind === "image_month") return `${t("tokens.unitImage")}/${t("tokens.unitMonth")}`;
  if (kind === "check_month") return `${t("tokens.unitCheck")}/${t("tokens.unitMonth")}`;
  return t(kind); // fallback to i18n key
};
